"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var MasterCard = function MasterCard() {
  return _react["default"].createElement("svg", {
    viewBox: "0 0 48 48"
  }, _react["default"].createElement("path", {
    fill: "#3F51B5",
    d: "M45,35c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V13c0-2.209,1.791-4,4-4h34c2.209,0,4,1.791,4,4V35z"
  }), _react["default"].createElement("path", {
    fill: "#FFC107",
    d: "M30 14A10 10 0 1 0 30 34A10 10 0 1 0 30 14Z"
  }), _react["default"].createElement("path", {
    fill: "#FF3D00",
    d: "M22.014,30c-0.464-0.617-0.863-1.284-1.176-2h5.325c0.278-0.636,0.496-1.304,0.637-2h-6.598C20.07,25.354,20,24.686,20,24h7c0-0.686-0.07-1.354-0.201-2h-6.598c0.142-0.696,0.359-1.364,0.637-2h5.325c-0.313-0.716-0.711-1.383-1.176-2h-2.973c0.437-0.58,0.93-1.122,1.481-1.595C21.747,14.909,19.481,14,17,14c-5.523,0-10,4.477-10,10s4.477,10,10,10c3.269,0,6.162-1.575,7.986-4H22.014z"
  }));
};
var _default = exports["default"] = MasterCard;